import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  Item_Code,
  ItemName,
  ItemDescription,
  Item_UOM,
  PackingUnit,
  PriceList,
  Customer,
  Supplier,
  BatchNo,
  Currency,
  Rate,
  ValidFrom,
  ValidUpto,
  LeadTimeindays,
  Note,
  Reference,
}) => {

  return (
    <>
     <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>

        <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Details</p>
                                    </div>
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                
                                   <Input
                    label="Item Code"
                    style={{
                      height: "30px",
                    }}
                    value={Item_Code.select_Item_Code}
                    readOnly
                  />
                                
                                </div>
                                <div style={{ flex: 1 }}>

                                   <Input
                    label="Item UOM"
                    style={{
                      height: "30px",
                    }}
                    value={Item_UOM.select_Item_UOM}
                    readOnly
                  />
                                   
                                </div>
                                <div style={{ flex: 1 }}>
                                   <Input
                    id="PackingUnit"
                    label="Packing Unit"
                    style={{
                      height: "30px",
                      border: PackingUnit.Error ? "1px solid red" : "",
                    }}
                    value={PackingUnit.PackingUnit}
                    onChange={(e) => PackingUnit.setPackingUnit(e.target.value)}
                    readOnly
                  />
                  <p
                    style={{
                      fontSize: "9px",
                      color: "#2C2B31",
                      marginLeft: "4px",
                    }}
                  >
                    Quantity that must be bought or sold per UOM
                  </p>
                                </div>
                                </div>
                            <div style={{  display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                    <Input
                    label="Price List"
                    style={{
                      height: "30px",
                    }}
                   value={PriceList?.PriceList || ""}
                    readOnly
                  />
                                   
                                </div>
                                 {PriceList?.PriceList === "Standard Selling" && (
                                <div style={{ flex: 1 }}>
                                    <Input
                    label="Customer"
                    style={{
                      height: "30px",
                    }}
                  value={Customer.select_Customer}
                    readOnly
                  />
                                  
                                </div>
                                 )}
                {PriceList?.PriceList === "Standard Buying" && (
                   <div style={{ flex: 1 }}>
                    <Input
                    label="Supplier"
                    style={{
                      height: "30px",
                    }}
                   value={Supplier.select_Supplier}
                    readOnly
                  />
                    
                  </div>
                )}
                 <div style={{ flex: 1 }}>
                   <Input
                    label="Batch No"
                    style={{
                      height: "30px",
                    }}
                    value={BatchNo.select_BatchNo}
                    readOnly
                  />
                                   
                                </div>
                            </div>
                         
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Price List Details</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                
                                <div style={{ flex: 1 }}>
                                  <Input
                    id="Currency"
                    label="Currency"
                    style={{
                      height: "30px",
                      border: Currency.Error ? "1px solid red" : "",
                    }}
                    value={Currency.Currency}
                    onChange={(e) => Currency.setCurrency(e.target.value)}
                    readOnly
                  />
                                </div>

                                <div style={{ flex: 1 }}>
                                
                                      <Input
                    id="Rate"
                    label="Rate"
                    style={{
                      height: "30px",
                      border: Rate.Error ? "1px solid red" : "",
                    }}
                    value={Rate.Rate}
                    onChange={(e) => Rate.setRate(e.target.value)}
                    readOnly
                  />
                                </div>
                                <div style={{ flex: 1 }}>
                  <Input
                    id="ValidFrom"
                    type="date"
                    label="Valid From"
                    style={{
                      height: "30px",
                      border: ValidFrom.Error ? "1px solid red" : "",
                    }}
                    value={ValidFrom.ValidFrom}
                    onChange={(e) => ValidFrom.setValidFrom(e.target.value)}
                    readOnly
                  />
                </div>
                            </div>
  <div style={{ display: 'flex', gap: '15px' }}>
    
                <div style={{ flex: 1 }}>
                  <Input
                    id="ValidUpto"
                    type="date"
                    label="Valid Upto"
                    style={{
                      height: "30px",
                      border: ValidUpto.Error ? "1px solid red" : "",
                    }}
                    value={ValidUpto.ValidUpto}
                    onChange={(e) => ValidUpto.setValidUpto(e.target.value)}
                    readOnly
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    id="LeadTimeindays"
                    label="Lead Time in days"
                    style={{
                      height: "30px",
                      border: LeadTimeindays.Error ? "1px solid red" : "",
                    }}
                    value={LeadTimeindays.LeadTimeindays}
                    onChange={(e) => LeadTimeindays.setLeadTimeindays(e.target.value)}
                    readOnly
                  />

                </div>
               
                <div style={{ flex: 1 }}>
                  <Input
                    id="Reference"
                    label="Reference"
                    style={{
                      height: "30px",
                      border: Reference.Error ? "1px solid red" : "",
                    }}
                    value={Reference.Reference}
                    onChange={(e) => Reference.setReference(e.target.value)}
                    readOnly
                  />

                </div>


              </div>

<div style={{ display: 'flex', gap: '15px' }}>
 <div style={{ flex: 1 }}>
                  <Input
                    id="Note"
                    label="Note"
                    style={{
                      height: "30px",
                      border: Note.Error ? "1px solid red" : "",
                    }}
                    value={Note.Note}
                    onChange={(e) => Note.setNote(e.target.value)}
                    readOnly
                  />
                </div>
</div>

                        </div>
                    </div>
                </div>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

            <div className="col-md-12 px-2">
              <div className='' style={{height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


                <ActivityCard doctype="Item Price" docname={IdData} />





              </div>
            </div>

          </div>

      </div>
    </div>
    
    </>
  );
};

export default Tab1;
